import { colorPalette } from '../../style/colorPalette'
import { StatusChip } from '../../components/data-display/StatusChip'

// プログラム行（PROGRAM）のステータス配色。現状は配下から集計したプロジェクト系
// ステータス（STANDBY/INPROGRESS/FINISHED/CANCELED）をそのまま表示するため、
// ProjectStatusChip と同じ配色だが、将来プログラム固有の体系に分岐できるよう別部品にしている。
const getProgramStatusStyles = (status: string) => {
  switch (status) {
    case 'STANDBY':
      return {
        backgroundColor: colorPalette.monotone[1],
        textColor: colorPalette.monotone[4],
        borderColor: `1px solid ${colorPalette.monotone[2]}`,
      }
    case 'INPROGRESS':
      return {
        backgroundColor: colorPalette.yellow[1],
        textColor: colorPalette.yellow[4],
        borderColor: `1px solid ${colorPalette.yellow[2]}`,
      }
    case 'FINISHED':
      return {
        backgroundColor: colorPalette.skyBlue[1],
        textColor: colorPalette.skyBlue[7],
        borderColor: `1px solid ${colorPalette.skyBlue[2]}`,
      }
    case 'CANCELED':
      return {
        backgroundColor: colorPalette.monotone[3],
        textColor: colorPalette.monotone[0],
        borderColor: `1px solid ${colorPalette.monotone[3]}`,
      }
    default:
      return {
        backgroundColor: colorPalette.monotone[0],
        textColor: colorPalette.monotone[10],
        borderColor: `1px solid ${colorPalette.monotone[10]}`,
      }
  }
}

type ProgramStatusChipProps = {
  status: string
}

export const ProgramStatusChip = ({ status }: ProgramStatusChipProps) => {
  const { backgroundColor, textColor, borderColor } =
    getProgramStatusStyles(status)
  return (
    <StatusChip
      label={status}
      backgroundColor={backgroundColor}
      textColor={textColor}
      borderColor={borderColor}
    />
  )
}
